import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import {InputAdornment, TextField, useMediaQuery} from "@mui/material";
import SimpleSelector from "../../../../components/Shared/SimpleSelector";
import SimpleText from "../../../../components/Shared/SimpleText";
import {
    FormControl,
    FormControlLabel,
    FormLabel, Grid,
    Radio,
    RadioGroup, Select,
    Tooltip,
} from "@mui/material";
import React, {useEffect, useState} from "react";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import {useParams} from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MenuItem from "@mui/material/MenuItem";
import {DesktopDatePicker} from "@mui/x-date-pickers";

const ContractInputs = (
  {
    reqData,
    setReqData,
    contractTypeOptions,
    contractReadjustmentIndex,
    contractReadjustmentMode,
    contractIsIncomeTax,
    adminTaxPreview,
    intermediationPreview,
    error,
  }) => {
  const params = useParams()
  const [includeIncomeTax, setIncludeIncomeTax] = useState(reqData?.is_income_tax);

  const sizeMatch = useMediaQuery('@media (min-width:730px)')

    const contractReadjustmentFormat = () => {

        const items = [
            {
                value: 'MANUALLY', label: 'Manualmente', disabled: false
            },
            {
                value: 'AUTOMATIC', label: 'Automático', disabled: reqData.readjustment_index === 'IPCA'
            }
        ]

        return items
    }

    useEffect(() => {
        if (reqData?.readjustment_index === 'IPCA') {

            setReqData((prevState) => ({
                ...prevState,
                readjustment_format: "MANUALLY"
            }))
        }
    }, [reqData?.readjustment_index])
  return (
    <>
      <DesktopDatePicker
        label={'Data de Início'}
        disabled={true}
        value={moment(reqData?.start_date).toDate() ?? ''}
        onChange={(newValue) => setReqData((prevState) => ({
          ...prevState,
          start_date: newValue
        }))}
        slotProps={{
            field: { clearable: false, onClear: () => {} },
            textField: {
                size: "small",
                inputProps: { readOnly: true },
            }
        }}
        sx={{
            mb: '1rem',
            width: '100%'
        }}
      />


      <SimpleSelector
        label={'Tipo de Contrato'}
        onlyNumbers
        state={reqData}
        setState={setReqData}
        keyName={'contract_type'}
        simpleOptions={contractTypeOptions}
        styles={{
          mb: '1rem',
          width: '100%'
          // maxWidth: reqData?.unit && sizeMatch ? '300px' : 'auto',

        }}
      />

      <SimpleText
        label={'Tempo de Contrato'}
        state={reqData}
        setState={setReqData}
        keyName={'contract_time'}
        error={error}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              meses
            </InputAdornment>
          )
        }}
        styles={{
          mb : '1rem',
          width: '100%',
          // maxWidth: reqData?.unit && sizeMatch ? '300px' : 'auto',

        }}

      />

      {/*<SimpleText*/}
      {/*  label={'Taxa Administrativa'}*/}
      {/*  float*/}
      {/*  required*/}
      {/*  directHelper={error?.administrative_tax ?? adminTaxPreview()}*/}
      {/*  onChange={(e) => setReqData(prevState => ({...prevState, administrative_tax: e.target.value?.slice(0,10)}))}*/}
      {/*  state={reqData}*/}
      {/*  // setState={setReqData}*/}
      {/*  keyName={'administrative_tax'}*/}
      {/*  error={error}*/}
      {/*  styles={{*/}
      {/*    width: '100%',*/}
      {/*    // maxWidth: reqData?.unit && sizeMatch ? '300px' : 'auto',*/}
      {/*    mb: '1rem',*/}
      {/*  }}*/}
      {/*  InputProps={{*/}
      {/*    endAdornment: (*/}
      {/*      <InputAdornment position="end">*/}
      {/*        <Percent />*/}
      {/*      </InputAdornment>*/}
      {/*    )*/}
      {/*  }}*/}
      {/*/>*/}

      {/*<SimpleText*/}
      {/*  label={'Taxa de Intermediação'}*/}
      {/*  float*/}
      {/*  directHelper={error?.intermediation_fee ?? intermediationPreview()}*/}
      {/*  state={reqData}*/}
      {/*  onChange={(e) => setReqData(prevState => ({...prevState, intermediation_fee: e.target.value?.slice(0,10)}))}*/}
      {/*  keyName={'intermediation_fee'}*/}
      {/*  error={error}*/}
      {/*  styles={{*/}
      {/*    width: '100%',*/}
      {/*    // maxWidth: reqData?.unit && sizeMatch ? '300px' : 'auto',*/}
      {/*    mb: '1rem',*/}
      {/*  }}*/}
      {/*  InputProps={{*/}
      {/*    endAdornment: (*/}
      {/*      <InputAdornment position="end">*/}
      {/*        <Percent />*/}
      {/*      </InputAdornment>*/}
      {/*    )*/}
      {/*  }}*/}
      {/*/>*/}



        <SimpleSelector
            label={'Indice para Reajuste'}
            state={reqData}
            setState={setReqData}
            keyName={'readjustment_index'}
            simpleIndexOptions={contractReadjustmentIndex}
            styles={{
                mb: '1rem',
                width: '100%'
                // maxWidth: reqData?.unit && sizeMatch ? '300px' : 'auto',

            }}
        />

        <SimpleSelector
            label={'Reajustar'}
            state={reqData}
            setState={setReqData}
            keyName={'readjustment_format'}
            simpleOptions={contractReadjustmentFormat()}
            styles={{
                mb: '1rem',
                width: '100%'
            }}
        />

        <SimpleSelector
            label={'Modo de Reajuste'}
            state={reqData}
            setState={setReqData}
            keyName={'readjustment_mode'}
            simpleIndexOptions={contractReadjustmentMode}
            styles={{
                mb: '1rem',
                width: '100%'
                // maxWidth: reqData?.unit && sizeMatch ? '300px' : 'auto',

            }}
        />
        <SimpleSelector
            label={'Habilitar dedução do IRRF'}
            onlyNumbers
            state={reqData}
            setState={setReqData}
            keyName={'is_income_tax'}
            simpleOptions={contractIsIncomeTax}
            styles={{
                mb: '1rem',
                width: '100%'
                // maxWidth: reqData?.unit && sizeMatch ? '300px' : 'auto',
            }}
        />
        <SimpleText
            label={'Número do Contrato'}
            state={reqData}
            setState={setReqData}
            keyName={'contract_number'}
            error={error}
            styles={{
                // maxWidth: reqData?.unit && sizeMatch ? '300px' : 'auto',
                width: '100%',
                mb: '1rem',
            }}
        />


      {/*  <SimpleText*/}
      {/*  label={'Valor'}*/}
      {/*  money*/}
      {/*  required*/}
      {/*  state={reqData}*/}
      {/*  setState={setReqData}*/}
      {/*  keyName={'value'}*/}
      {/*  error={error}*/}
      {/*  styles={{*/}
      {/*    // maxWidth: reqData?.unit && sizeMatch ? '300px' : 'auto',*/}
      {/*    width: '100%',*/}
      {/*    mb: '1rem',*/}
      {/*  }}*/}
      {/*/>*/}


      {params?.id && reqData?.status !== 'pending' &&
        <ToggleButtonGroup
          fullWidth
          size={'small'}
          exclusive
          value={reqData?.active}
          color={'primary'}
          onChange={(e, value) => setReqData(prevState => ({
            ...prevState,
            status: value
          }))}
          sx={{
            // maxWidth: reqData?.unit && sizeMatch ? '300px' : '300px'
            width: '100%',

          }}
        >
          <ToggleButton
            value={'inactive'}
            selected={reqData?.status === 'inactive'}
          >
            Encerrado
          </ToggleButton>
          <ToggleButton
            value={'active'}
            selected={reqData?.status === 'active'}
            sx={{
              '&.Mui-selected': {
                color: '#3d3d3d',
                backgroundColor: 'rgba(0,255,0,0.38)',
                '&:hover': {
                  backgroundColor: 'rgba(0, 255, 0, 0.7)',
                },
              },
            }}
          >
            Ativo
          </ToggleButton>
        </ToggleButtonGroup>
      }

    </>
  )
}

export default ContractInputs